<div class="icon-container">
  <mat-icon id="icon" [inline]="true" [fontSet]="getFontSet()">
    <ng-content></ng-content>
  </mat-icon>
</div>
